export default {"src":"/_next/static/image/public/images/ic_reports_sync.5bc1df6d787597d99e3a10fedc4b2222.svg","height":38,"width":38};